import { useAlertStore } from "@/stores/alert.store";

const statusCodeMessages: { [key: number]: string } = {
  1: "Login ou senha inválidos",
  2: "Login inválido",
  3: "Erro no servidor",
  4: "Erro de autenticação",
  5: "Dados inválidos",
  6: "Usuário não encontrado",
  7: "Usuário já existe",
  8: "Usuário atualizado com sucesso",
  9: "Usuário excluído com sucesso",
  10: "Novo usuário criado com sucesso",
  11: "Token inválido",
  12: "Token expirado",
  13: "Logout do sistema",
  14: "Integração ativada",
  15: "Integração desativada",
  16: "Integração não encontrada",
  17: "Nova integração criada com sucesso",
  18: "Conector IN não encontrado",
  19: "Conector OUT não encontrado",
  20: "Integração atualizada com sucesso",
  21: "Integração excluída com sucesso",
  22: "Integração não encontrada",
  23: "Modelos de Conector IN não encontrados",
  24: "Modelos de Conector OUT não encontrados",
  25: "Execução não encontrada",
  26: "Empresa não encontrada",
  27: "Empresa atualizada com sucesso",
  28: "Assinatura não encontradas",
  29: "Assinatura atualizada com sucesso",
  30: "Planos não encontrados",
  31: "CNPJ já cadastrado",
  32: "Novo plano criado com sucesso",
  33: "Plano atualizado com sucesso",
  34: "Plano excluído com sucesso",
  35: "Novo pagamento criado com sucesso",
  36: "Pagamento atualizado com sucesso",
  37: "Pagamento excluído com sucesso",
  38: "Pagamento não encontrado",
  39: "Assinatura cancelada com sucesso",
  40: "Cliente ASAAAS não encontrado",
  41: "O cliente já possui uma assinatura ativa",
  42: "Conector já cadastrado",
  43: "Parâmetros inválidos",
  44: "Conector de Entrada atualizado com sucesso",
  45: "Conector de Saída atualizado com sucesso",
  46: "Conector de Entrada removido com sucesso",
  47: "Conector de Saída removido com sucesso",
  48: "A senha é muito fraca",
  49: "Código do MFA é inválido",
  50: "Parâmetros MFA ausentes",
  51: "Sessão do MFA inválida",
  52: "Verificação do MFA expirada",
  53: "Configuração do MFA necessária",
  54: "Privilégios insuficientes",
  55: "Assinatura cancelada ou bloqueada",
  56: "Não é possível reassinar. Existem pagamentos em atraso que precisam ser regularizados",
  57: "Task não encontrada",
  58: "Plano bloqueado para o usuário. Selecione um plano com valor maior",
  99: "Erro ao processar webhook",
};

export function handleApiError(statusCode: number) {
  const message = statusCodeMessages[statusCode] || "Erro desconhecido";
  useAlertStore().show("error", message);
}

export const getStatusCodeMessages = () => statusCodeMessages;
